import { provideStore } from '@ngrx/store';
import { provideEffects } from '@ngrx/effects';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { isDevMode } from '@angular/core';

// Import feature reducers (extracted from createFeature)
import { fidPickerReducer } from '../../pages/fid-picker/store/fid-picker.reducer';
import { dataReadinessReducer } from '../../pages/data-readiness/store/data-readiness.reducer';
import { dataViewerReducer } from '../../pages/data-viewer/store/data-viewer.reducer';

// Import effects
import { FidPickerEffects } from '../../pages/fid-picker/store/fid-picker.effects';

// Store configuration with all page features
export const storeConfig = [
  // Store with all page features
  // Note: Each reducer is extracted from createFeature for automatic selector generation
  provideStore({
    fidPicker: fidPickerReducer,           // ← From fidPickerFeature.reducer
    dataReadiness: dataReadinessReducer,   // ← From dataReadinessFeature.reducer
    dataViewer: dataViewerReducer,         // ← From dataViewerFeature.reducer
  }),

  // Effects - handles side effects like API calls
  provideEffects([
    FidPickerEffects, // ← Complete example showing service integration
    // Add other effects here as they are created
  ]),

  // DevTools for development
  provideStoreDevtools({
    maxAge: 25,
    logOnly: !isDevMode(),
  }),
]; 